import { clsx } from 'clsx';
import { useParams } from 'react-router';

import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import timerSVG from '../../assets/timer.svg';
import { useGetIntegrationStatus } from '../../hooks/useGetIntegrationStatus.hook';
import { Integration } from '../../utils/integrations.types';

export function IntegrationButton({
  integration,
  handleClick,
}: {
  integration: Integration;
  handleClick: () => void;
}) {
  const { integrationStatus } = useGetIntegrationStatus({
    integrationId: integration.id,
  });
  const { integrationParam } = useParams();

  if (integration.disabled) {
    return (
      <div className="mb-l flex flex-col justify-between px-l py-s text-left">
        <div className="opacity-40">
          <div className="text-xs font-med text-secondary-40">
            {integration.company_type}
          </div>
          <div className="pt-[0.2rem] text-l font-bold">
            {integration.company_name}
          </div>
        </div>
        <div className="flex items-center pl-[0.1rem] pt-[0.3rem] text-xs font-reg text-structure-40 opacity-100">
          <img src={timerSVG} alt="Timer Icon" className="pr-[0.4rem]" />
          We're working on it!
        </div>
      </div>
    );
  }
  return (
    <LinkWithQuery
      className="no-underline"
      to={`/pay/integrations/${integration.id}`}
      onClick={() => handleClick()}
    >
      <div
        className={clsx(
          'mb-l flex cursor-pointer flex-row justify-between rounded-s border-2 border-transparent bg-transparent p-l text-left text-primary-10 hover:border-2 hover:border-transparent hover:bg-secondary-97',
          {
            '!border-2 !border-primary-40 !bg-secondary-97 !shadow-black-m':
              integrationParam === integration.id,
          },
        )}
      >
        <div className="flex">
          <img
            src={integration.company_logo_svg}
            alt="Logo"
            className="m-auto mr-l aspect-square w-2xl"
          />
          <div className="m-auto">
            <div className="text-xs font-med text-secondary-40">
              {integration.company_type}
            </div>
            <div className="pt-[0.2rem] text-l font-bold">
              {integration.company_name}
            </div>
          </div>
        </div>
        {integrationStatus === 'CONNECTED' && (
          <div className="text-xs font-reg text-success-drk">Connected</div>
        )}
      </div>
    </LinkWithQuery>
  );
}
